export const PAYPAL_INFO = "PAYPAL_INFO";

export default (state = null, action) => {
    switch (action.type) {
        case PAYPAL_INFO:
            return action.payload;
        default:
            return state;
    }
}
